import axios from 'axios';
import { SCREEN_SM_MIN } from '../constants/spacingConstants';

export const EXPLAINER_LEASE_PREFIX = `explainers`;
export const staticUrl = 'https://files.zillowrentals.com/leasing-web';

/**
 * Opens a static asset in a new tab if desktop or in current tab if on mobile
 * @param url
 */
export function openStaticAsset(filename: string) {
  const url = `${staticUrl}/${filename}`;
  const isMobile = document.body.getBoundingClientRect().width < SCREEN_SM_MIN;

  if (isMobile) {
    // This condition is a special snowflake. When on mobile view, can't open directly to _self when content-type is
    // 'application/pdf'. Escape hatch is to create object URL and redirect to that
    // eslint-disable-next-line promise/catch-or-return
    axios({
      url,
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      const url = window['URL']?.createObjectURL(response.data);

      // eslint-disable-next-line promise/always-return
      if (url) {
        window.open(url, '_self');
      }
    });
  } else {
    const newTab = window.open(url, '_blank');

    if (newTab) {
      newTab.focus();
    }
  }
}
